export default __webpack_public_path__ + "static/media/third.917359a1.jpg";